module.exports = __webpack_public_path__ + "static/better-flag-540w-090718-2a660392dc8984be0d731cee9886970b.jpg";